export const getAcceptLanguageHeader = (primaryLanguage: string): { 'accept-language': string } => {
  return { 'accept-language': `${primaryLanguage}, en;q=0.5` };
};
